// ROMはローマ字の略

export const QUESTIONS = [
  {
    ID: 1,
    TYPE: "normal",
    QUESTION: "どうも、みなさん、\nこんたかたー！\nMr.Takata Channelの\nタカタです",
    ANSWER_JP: "いつも応援しています",
    ANSWER_ROM: "itumoouensiteimasu",
    EXPLANATION: "解説1です",
    OPTION_1_JP: "",
    OPTION_1_ROM: "",
    OPTION_2_JP: "",
    OPTION_2_ROM: "",
    OPTION_3_JP: "",
    OPTION_3_ROM: "",
  },
  {
    ID: 2,
    TYPE: "normal",
    QUESTION: "今日は皆さんに\n問題を出します！\n難問ですが、\n何問正解できるかな？",
    ANSWER_JP: "よーし、全問正解するぞ!",
    ANSWER_ROM: "yo-si,zenmonseikaisuruzo!",
    EXPLANATION: "解説2です",
    OPTION_1_JP: "",
    OPTION_1_ROM: "",
    OPTION_2_JP: "",
    OPTION_2_ROM: "",
    OPTION_3_JP: "",
    OPTION_3_ROM: "",
  },
  {
    ID: 3,
    TYPE: "quiz",
    QUESTION:
      "スーパークラスで定義\nされたメソッドを\nサブクラスで再定義\nするものはどれ？",
    ANSWER_JP: "オーバーライド",
    ANSWER_ROM: "over ride",
    EXPLANATION: "解説3です",
    OPTION_1_JP: "オーバーライド",
    OPTION_1_ROM: "over ride",
    OPTION_2_JP: "オーバーロード",
    OPTION_2_ROM: "over load",
    OPTION_3_JP: "オブジェクト指向",
    OPTION_3_ROM: "object oriented",
  },
  {
    ID: 4,
    TYPE: "quiz",
    QUESTION: "コピーの\nショートカットは？",
    ANSWER_JP: "Ctrl+C",
    ANSWER_ROM: "Ctrl+C",
    EXPLANATION: "解説4です",
    OPTION_1_JP: "Ctrl+C",
    OPTION_1_ROM: "Ctrl+C",
    OPTION_2_JP: "Shift+C",
    OPTION_2_ROM: "Shift+C",
    OPTION_3_JP: "Alt+C",
    OPTION_3_ROM: "Alt+C",
  },
  {
    ID: 5,
    TYPE: "normal",
    QUESTION: "Javaのmainメソッド宣言\n「public static void main」\nの続きは？",
    ANSWER_JP: "(String[] args)",
    ANSWER_ROM: "(String[] args)",
    EXPLANATION: "解説5です",
    OPTION_1_JP: "",
    OPTION_1_ROM: "",
    OPTION_2_JP: "",
    OPTION_2_ROM: "",
    OPTION_3_JP: "",
    OPTION_3_ROM: "",
  },
  {
    ID: 6,
    TYPE: "normal",
    QUESTION: "ここでいったん、\n小休憩としましょう",
    ANSWER_JP: "(*^-^*)",
    ANSWER_ROM: "(*^-^*)",
    EXPLANATION: "解説6です",
    OPTION_1_JP: "",
    OPTION_1_ROM: "",
    OPTION_2_JP: "",
    OPTION_2_ROM: "",
    OPTION_3_JP: "",
    OPTION_3_ROM: "",
  },
  {
    ID: 7,
    TYPE: "quiz",
    QUESTION: "実在しない資格はどれ？\n➀基本技術者試験\n➁応用情報技術者試験\n➂簡単情報技術者試験",
    ANSWER_JP: "簡単情報技術者試験",
    ANSWER_ROM: "kantanjouhougijutushasiken",
    EXPLANATION: "解説7です",
    OPTION_1_JP: "基本情報技術者試験",
    OPTION_1_ROM: "kihonjouhougijutushasiken",
    OPTION_2_JP: "応用情報技術者試験",
    OPTION_2_ROM: "ouyoujouhougijutushasiken",
    OPTION_3_JP: "簡単情報技術者試験",
    OPTION_3_ROM: "kantanjouhougijutushasiken",
  },
  {
    ID: 8,
    TYPE: "quiz",
    QUESTION: "ＡＷＳとはなんの略語？",
    ANSWER_JP: "アマゾンウェブサービス",
    ANSWER_ROM: "amazon web service",
    EXPLANATION: "解説8です",
    OPTION_1_JP: "アマゾンウェブサービス",
    OPTION_1_ROM: "amazon web service",
    OPTION_2_JP: "アマゾンワールドサービス",
    OPTION_2_ROM: "amazon world service",
    OPTION_3_JP: "アマゾンワールドセキュリティ",
    OPTION_3_ROM: "amazon world security",
  },
  {
    ID: 9,
    TYPE: "normal",
    QUESTION: "フリースタイルの\n高田さんの本名は？\n※私ではありません",
    ANSWER_JP: "高田・ビニシウス・ヒュージ",
    ANSWER_ROM: "Takada Vynicius riuji",
    EXPLANATION: "解説9です",
    OPTION_1_JP: "",
    OPTION_1_ROM: "",
    OPTION_2_JP: "",
    OPTION_2_ROM: "",
    OPTION_3_JP: "",
    OPTION_3_ROM: "",
  },
  {
    ID: 10,
    TYPE: "normal",
    QUESTION: "今日はここまでです。\nおつたかです～",
    ANSWER_JP: "おつたかたー",
    ANSWER_ROM: "otutakata-",
    EXPLANATION: "解説10です",
    OPTION_1_JP: "",
    OPTION_1_ROM: "",
    OPTION_2_JP: "",
    OPTION_2_ROM: "",
    OPTION_3_JP: "",
    OPTION_3_ROM: "",
  }
];
